import { Route, Routes, useParams } from "react-router-dom";
import SignIn from "./components/SignIn/SignIn";
import SignUp from "./containers/SignUp";
import Dashboard from "./containers/Dashboard";
import ForgotPassword from "./components/SignIn/ForgotPassword";
import ForgotUsername from "./components/SignIn/ForgotUsername";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import SetPassword from "./components/ResetPassword/SetPassword";
import MarketPlace from "./containers/Marketplace";
import Complete from "./components/MarketPlace/CompletePurchase";
import Schedule from "./containers/Schedules";
import Profile from "./containers/Profile";
import ChangePassword from "./components/ResetPassword/ChangePassword";
import Enroll from "./containers/Enroll";
import ErrorPage from "./components/AlertMessage/ErrorPage";
import PrivateRoute from "./hoc/PrivateRoute";
import OpenRoute from "./hoc/OpenRoute";

const PathErrorChecker = () => {
    const { path } = useParams();
    const pathList = [
        "dashboard", "schedule", "marketplace", 
        "profile", "signin", "signup", 
        "forgot", "password"
    ];
    
    if (pathList?.includes(path as string)) {
        return null;
    }
    return <ErrorPage />;
};

const AppRoutes = () => {
    // const pathList: any = [
    //     "dashboard",
    //     "schedule",
    //     "marketplace",
    //     "profile",
    //     "signin",
    //     "signup",
    //     "forgot",
    //     "password",
    // ];
    
    return (
        <Routes>
            {/* Public routes */}
            <Route path="/:id/" element={<SignIn />} />
            <Route path="/:id/signin" element={<SignIn />} />
            
            {/* Open routes - assuming OpenRoute is also updated for v6 */}
            <Route element={<OpenRoute />}>
                <Route path="/:id/signup" element={<SignUp />} />
                <Route path="/:id/forgot/password" element={<ForgotPassword />} />
                <Route path="/:id/forgot/username" element={<ForgotUsername />} />
                <Route path="/:id/resetpassword" element={<ResetPassword />} />
                <Route path="/:id/changepassword" element={<ChangePassword />} />
                <Route path="/:id/setpassword" element={<SetPassword />} />
            </Route>
            
            {/* Protected routes */}
            <Route element={<PrivateRoute />}>
                <Route path="/:id/dashboard" element={<Dashboard />} />
                <Route path="/:id/schedule/*" element={<Schedule />} />
                <Route path="/:id/marketplace" element={<MarketPlace />} />
                <Route path="/:id/marketplace/cart/complete" element={<Complete />} />
                <Route path="/:id/enroll" element={<Enroll />} />
                <Route path="/:id/profile/*" element={<Profile />} />
            </Route>
            
            {/* Error routes */}
            <Route path="/:id/:path" element={<PathErrorChecker />} />
            <Route path="/" element={<ErrorPage />} />
        </Routes>
    );
};

export default AppRoutes;